import { useState } from 'react';
import { useNavigate } from 'react-router';
import ArrowLeftImage from '../../../assets/icons/arrow_left.png';
import { useToast } from '../../../context/ToastContext';
import { CAT_RUNNING_BATTLE } from '../assets';
import summonFriends from '../../../services/summoner';

const BATTLE_TABS = [
  { key: 'friend-battle', label: '친구배틀', enabled: true },
  { key: 'random-battle', label: '랜덤배틀', enabled: true },
  { key: 'friend-search', label: '친구찾기', enabled: true },
  { key: 'friend-invite', label: '친구초대', enabled: true },
];

const BATTLE_TITLE = {
  'friend-battle': { icon: CAT_RUNNING_BATTLE.swords, label: '친구배틀' },
  'random-battle': { icon: CAT_RUNNING_BATTLE.random, label: '랜덤배틀' },
  'friend-search': { icon: CAT_RUNNING_BATTLE.search, label: '친구찾기' },
  'friend-invite': { icon: CAT_RUNNING_BATTLE.invite, label: '친구초대' },
};

const BATTLE_INFO = {
  'friend-battle': {
    rules: ['도전 시 간식 2개 소비', '하루 1승 도전 가능 (자정 초기화)', '패배 시 재도전 최대 4회 (3,4,5,6개 누적 소비)'],
    reward: '친구배틀 승리 : 포인트 1.5배',
  },
  'random-battle': {
    rules: ['도전 시 간식 4개 소비', '하루 1승 도전 가능 (자정 초기화)', '패배 시 재도전 최대 4회 (5,6,7,8개 누적 소비)'],
    reward: '친구배틀 승리 : 포인트 1.7배',
  },
};

const FRIEND_BATTLES = [
  { id: 1, nickname: '냥냥이', bestDistanceM: 500, unlocked: true, snackCost: 4 },
  { id: 2, nickname: '냥냥이', bestDistanceM: 500, unlocked: false, unlockDistanceM: 500 },
  { id: 3, nickname: '냥냥이', bestDistanceM: 500, unlocked: false, unlockDistanceM: 500 },
  { id: 4, nickname: '냥냥이', bestDistanceM: 500, unlocked: false, unlockDistanceM: 500 },
];

const RANDOM_SLOT_EMOJIS = ['🥷', '🧑‍🚀', '😼'];

function BattleTab({ label, isActive, enabled, onClick }) {
  return (
    <button
      type="button"
      disabled={!enabled}
      onClick={onClick}
      className={[
        'flex h-[46px] flex-1 items-center justify-center border-0 py-3 font-[\'DungGeunMo\'] text-[16px] leading-[1.4]',
        isActive ? 'bg-white text-black' : 'bg-white/50 text-white/50',
        enabled ? '' : 'cursor-default',
      ].join(' ')}
    >
      {label}
    </button>
  );
}

function OpponentInfo({ nickname, bestDistanceM }) {
  return (
    <div className="w-[104px] shrink-0">
      <p className="m-0 font-['DungGeunMo'] text-[16px] leading-[1.4] text-black">{nickname}</p>
      <p className="m-0 font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#5e5e5e]">최고기록 {bestDistanceM}m</p>
    </div>
  );
}

function ChallengeButton({ snackCost, onClick, disabled }) {
  return (
    <button
      type="button"
      // onClick={onClick}
      disabled={disabled}
      className="ml-auto flex items-center gap-[10px] border-0 bg-[#333333] px-[15px] py-[5px] disabled:opacity-60"
    >
      <span className="font-['DungGeunMo'] text-[16px] leading-[1.4] text-white">도전</span>
      <img src={CAT_RUNNING_BATTLE.snack} alt="" className="h-[14px] w-4 object-contain" />
      <span className="font-['DungGeunMo'] text-[16px] leading-[1.4] text-white">{snackCost}</span>
    </button>
  );
}

function FriendBattleRow({ battle }) {
  return (
    <div
      className={`flex h-[75px] items-center gap-[10px] overflow-hidden px-5 py-[10px] ${
        battle.unlocked ? 'bg-[#8b68dd]/30' : 'bg-[#d9d9d9] opacity-50'
      }`}
    >
      <img src={CAT_RUNNING_BATTLE.avatarCat} alt="" className="h-6 w-6 shrink-0 object-contain" />
      <OpponentInfo nickname={battle.nickname} bestDistanceM={battle.bestDistanceM} />
      {battle.unlocked ? (
        <ChallengeButton snackCost={battle.snackCost} />
      ) : (
        <div className="ml-auto flex items-center gap-[10px]">
          <img src={CAT_RUNNING_BATTLE.lock} alt="" className="h-6 w-6 object-contain" />
          <span className="font-['DungGeunMo'] text-[16px] leading-[1.4] text-[#333333]">
            {battle.unlockDistanceM}m 달성시 해금
          </span>
        </div>
      )}
    </div>
  );
}

function RandomBattleRow({ battle, onChallenge, challengingSlotNo }) {
  const won = battle.result === 'won';
  return (
    <div
      className={`flex h-[75px] items-center gap-[10px] overflow-hidden px-5 py-[10px] ${
        won ? 'bg-black/[0.12]' : 'bg-[#8b68dd]/30'
      }`}
    >
      <span className="w-8 shrink-0 text-center text-[24px] leading-none">{battle.emoji}</span>
      <OpponentInfo nickname={battle.nickname} bestDistanceM={battle.bestDistanceM} />
      {won ? (
        <div className="ml-auto flex items-center gap-[5px] bg-[#3b5cd2] px-[15px] py-[5px]">
          <img src={CAT_RUNNING_BATTLE.win} alt="" className="h-6 w-6 object-contain" />
          <span className="font-['DungGeunMo'] text-[16px] leading-[1.4] text-white">승리</span>
        </div>
      ) : (
        <ChallengeButton
          snackCost={battle.snackCost}
          onClick={() => onChallenge?.(battle.slotNo)}
          disabled={!battle.playable || challengingSlotNo === battle.slotNo}
        />
      )}
    </div>
  );
}

function FriendSearchContent() {
  const [searchType, setSearchType] = useState('code');
  const isCode = searchType === 'code';

  return (
    <div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => setSearchType('code')}
          className={`flex h-[50px] flex-1 items-center justify-center border-0 font-['DungGeunMo'] text-[16px] leading-[1.4] text-white ${
            isCode ? 'bg-[#3b5cd2]' : 'bg-[#d9d9d9]'
          }`}
        >
          초대코드로 검색
        </button>
        <button
          type="button"
          onClick={() => setSearchType('id')}
          className={`flex h-[50px] flex-1 items-center justify-center border-0 font-['DungGeunMo'] text-[16px] leading-[1.4] text-white ${
            isCode ? 'bg-[#d9d9d9]' : 'bg-[#3b5cd2]'
          }`}
        >
          아이디로 검색
        </button>
      </div>

      <div className="mt-[42px] flex gap-2">
        <input
          type="text"
          placeholder={isCode ? '초대코드 입력(예:cat)' : '아이디 입력'}
          className="h-12 min-w-0 flex-1 border border-[#d9d9d9] bg-white px-3 text-center font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#333333] placeholder:text-[#919191] focus:outline-none"
        />
        <button
          type="button"
          className="flex h-12 flex-1 items-center justify-center gap-[10px] border-0 bg-[#333333] font-['DungGeunMo'] text-[16px] leading-[1.4] text-white"
        >
          <img src={CAT_RUNNING_BATTLE.search} alt="" className="h-8 w-8 object-contain" />
          검색
        </button>
      </div>

      <p className="mt-12 text-center font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#5e5e5e]">
        코드 또는 아이디 입력하고 검색
      </p>
      <div className="mt-[30px] h-px w-full bg-[#d9d9d9]" />
    </div>
  );
}

function InviteSection({ icon, title, children }) {
  return (
    <div className="flex flex-col items-center gap-[30px]">
      <div className="flex flex-col items-center">
        <img src={icon} alt="" className="h-10 w-10 object-contain" />
        <p className="m-0 font-['DungGeunMo'] text-[18px] leading-[1.4] text-black">{title}</p>
      </div>
      <div className="flex w-full flex-col items-center gap-4">{children}</div>
    </div>
  );
}

function FriendInviteContent({ inviteCode, invitedFriendCount, onKakaoInvite, onCopyInviteCode }) {
  return (
    <div className="flex flex-col gap-10">
      <InviteSection icon={CAT_RUNNING_BATTLE.chat} title="카카오톡으로 친구 초대">
        <div className="w-full border-[3px] border-black bg-[#f4f4f4] px-4 py-[21px] text-center font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#333333]">
          <p className="m-0">캣러닝 게임 같이하자 ! 😺</p>
          <p className="m-0">내 기록을 이길 수 있으면 도전해봐 !</p>
          <p className="m-0">초대코드 : {inviteCode || '불러오는 중'}</p>
        </div>
        <div className="text-center font-['DungGeunMo'] text-[12px] leading-[1.4] text-[#5e5e5e]">
          <p className="m-0">버튼을 누르면 초대 메세지가 복사됩니다.</p>
          <p className="m-0">친구에게 보내세요 !</p>
        </div>
        <button
          type="button"
          onClick={onKakaoInvite}
          className="flex h-[46px] w-full items-center justify-center border-0 bg-[#fee500] font-['DungGeunMo'] text-[16px] leading-[1.4] text-[#333333]"
        >
          카카오톡 초대하기
        </button>
      </InviteSection>

      <InviteSection icon={CAT_RUNNING_BATTLE.link} title="초대링크 복사">
        <p className="m-0 text-center font-['DungGeunMo'] text-[12px] leading-[1.4] text-[#5e5e5e]">
          초대링크를 공유해보세요 !
        </p>
        <button
          type="button"
          onClick={onCopyInviteCode}
          className="flex h-[46px] w-full items-center justify-center border-0 bg-[#7281dc] font-['DungGeunMo'] text-[16px] leading-[1.4] text-white"
        >
          링크 복사하기
        </button>
      </InviteSection>

      <div className="border-[3px] border-black bg-[#e2e6ff] px-[25px] py-[22px]">
        <div className="flex flex-col items-center gap-[10px]">
          <div className="flex w-full items-center gap-[10px]">
            <img src={CAT_RUNNING_BATTLE.gift} alt="" className="h-6 w-6 object-contain" />
            <span className="flex-1 font-['DungGeunMo'] text-[16px] leading-[1.4] text-[#333333]">초대 보상</span>
          </div>
          <div className="h-px w-full bg-black/15" />
          <p className="m-0 w-full font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#333333]">초대한 친구 수 : {invitedFriendCount}명</p>
          <div className="flex w-full items-center gap-2 font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#333333]">
            <span>1명 초대 당</span>
            <img src={CAT_RUNNING_BATTLE.snack} alt="" className="h-[14px] w-4 object-contain" />
            <span>간식 10개</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function CatRunningFriendBattleScreen({
  inviteCode = '',
  invitedFriendCount = 0,
  snackCount = 0,
  bestDistanceM = 0,
  randomSlots = [],
  randomFreeRefresh = false,
  randomRefreshAvailable = false,
  isRefreshing = false,
  onRefresh,
  onChallenge,
  challengingSlotNo = null,
}) {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [activeTab, setActiveTab] = useState('friend-battle');

  const isRandom = activeTab === 'random-battle';
  const isBattleTab = activeTab === 'friend-battle' || activeTab === 'random-battle';
  const isSearch = activeTab === 'friend-search';
  const isInvite = activeTab === 'friend-invite';
  const title = BATTLE_TITLE[activeTab];
  const info = BATTLE_INFO[activeTab];

  const randomRows = randomSlots.map((slot, index) => ({
    id: slot.slotNo ?? index,
    slotNo: slot.slotNo,
    emoji: RANDOM_SLOT_EMOJIS[index % RANDOM_SLOT_EMOJIS.length],
    nickname: slot.displayName || '냥냥이',
    bestDistanceM: slot.targetDistanceM ?? 0,
    result: slot.wonToday ? 'won' : 'challenge',
    snackCost: slot.nextSnackCost ?? 0,
    playable: slot.playable !== false,
  }));

  const handleCopy = async () => {
    if (!inviteCode) return;
    try {
      await navigator.clipboard.writeText(inviteCode);
      showToast('초대코드가 복사되었어요');
    } catch (error) {
      console.error('Failed to copy invite code', error);
      showToast('복사에 실패했어요. 다시 시도해주세요.', { type: 'error' });
    }
  };

  const handleKakaoInvite = () => {
    if (!inviteCode) return;
    summonFriends(1, inviteCode);
  };

  return (
    <div className="min-h-screen bg-black">
      <div className="mx-auto min-h-screen w-full max-w-[500px] bg-black">
        {/* Header */}
        <div className="px-[10px]">
          <div className="flex h-[46px] items-center">
            <button
              type="button"
              className="flex h-6 w-6 items-center justify-center border-0 bg-transparent p-0"
              onClick={() => navigate(-1)}
              aria-label="뒤로가기"
            >
              <img src={ArrowLeftImage} alt="" className="h-6 w-6 object-contain brightness-0 invert" />
            </button>
          </div>

          <div className="mt-[10px] flex items-center justify-center gap-[10px]">
            <img src={title.icon} alt="" className="h-8 w-8 object-contain" />
            <h1 className="m-0 font-['DungGeunMo'] text-[30px] leading-[1.4] text-white">{title.label}</h1>
          </div>

          {/* 초대코드 */}
          <div className="mt-[30px] flex h-[66px] items-center justify-between border-[3px] border-[#8b68dd] px-[10px]">
            <div className="flex min-w-0 items-center gap-[10px] font-['DungGeunMo'] text-white">
              <span className="text-[16px] leading-[1.4]">내 초대코드</span>
              <span className="text-[20px] leading-[1.4] tracking-[0.04em]">{inviteCode}</span>
            </div>
            <button
              type="button"
              className="flex h-[46px] shrink-0 items-center gap-[5px] border-0 bg-[#8b68dd] px-5"
              onClick={handleCopy}
            >
              <img src={CAT_RUNNING_BATTLE.copy} alt="" className="h-10 w-10 object-contain" />
              <span className="font-['DungGeunMo'] text-[16px] leading-[1.4] text-white">복사</span>
            </button>
          </div>
        </div>

        {/* 탭 */}
        <div className="mt-[22px] flex px-[10px]">
          {BATTLE_TABS.map((tab) => (
            <BattleTab
              key={tab.key}
              label={tab.label}
              isActive={tab.key === activeTab}
              enabled={tab.enabled}
              onClick={() => tab.enabled && setActiveTab(tab.key)}
            />
          ))}
        </div>

        {/* 흰색 본문 */}
        <div className="bg-white px-[10px] pb-14 pt-7">
          {isSearch && <FriendSearchContent />}
          {isInvite && (
            <FriendInviteContent
              inviteCode={inviteCode}
              invitedFriendCount={invitedFriendCount}
              onKakaoInvite={handleKakaoInvite}
              onCopyInviteCode={handleCopy}
            />
          )}
          {isBattleTab && (
          <div className="flex flex-col gap-[30px]">
            {/* 상대 목록 */}
            <div className="flex flex-col gap-[15px]">
              <div className="flex items-center justify-between px-[10px]">
                <div className="flex items-center gap-[5px]">
                  <img src={CAT_RUNNING_BATTLE.friends} alt="" className="h-8 w-8 object-contain" />
                  <span className="font-['DungGeunMo'] text-[16px] leading-[1.4] text-[#333333]">
                    {isRandom ? `랜덤 상대 ${randomRows.length}명` : '내 친구 15명'}
                  </span>
                </div>
                {isRandom ? (
                  <div className="relative flex items-center">
                    {randomFreeRefresh && (
                      <span className="absolute -top-3 right-0 rounded-[5px] bg-[#ff3b30] px-[5px] font-['DungGeunMo'] text-[12px] leading-[1.4] text-white">
                        무료 1회
                      </span>
                    )}
                    <button
                      type="button"
                      onClick={onRefresh}
                      disabled={isRefreshing || !randomRefreshAvailable}
                      className="flex h-8 items-center justify-center border-0 bg-[#03c75a] px-[10px] font-['DungGeunMo'] text-[12px] leading-[1.4] text-white disabled:opacity-60"
                    >
                      {isRefreshing ? '갱신중' : '리프레쉬'}
                    </button>
                  </div>
                ) : (
                  <span className="font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#333333]">도전할 친구 선택</span>
                )}
              </div>

              <div className="flex flex-col gap-[10px]">
                {isRandom ? (
                  randomRows.length > 0 ? (
                    randomRows.map((battle) => (
                      <RandomBattleRow
                        key={battle.id}
                        battle={battle}
                        onChallenge={onChallenge}
                        challengingSlotNo={challengingSlotNo}
                      />
                    ))
                  ) : (
                    <p className="py-6 text-center font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#919191]">
                      랜덤 상대를 불러오는 중...
                    </p>
                  )
                ) : (
                  FRIEND_BATTLES.map((battle) => <FriendBattleRow key={battle.id} battle={battle} />)
                )}
              </div>
            </div>

            {/* 안내 */}
            <div className="flex flex-col gap-[15px]">
              <div className="flex items-center justify-between px-[10px]">
                <div className="flex items-center gap-[10px]">
                  <img src={title.icon} alt="" className="h-6 w-6 object-contain" />
                  <span className="font-['DungGeunMo'] text-[16px] leading-[1.4] text-black">{title.label}</span>
                </div>
                <div className="flex items-center gap-[10px] font-['DungGeunMo'] text-[14px] leading-[1.4]">
                  <span className="text-[#8b68dd]">내 최고기록 : {bestDistanceM}m</span>
                  <span className="h-3 w-[3px] bg-[#d9d9d9]" />
                  <span className="text-[#3b5cd2]">간식 : {snackCount}</span>
                </div>
              </div>

              <div className="border-[3px] border-black bg-[#e2e6ff] px-5 py-[18px]">
                <ul className="m-0 list-disc space-y-[6px] pl-5 font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#333333]">
                  {info.rules.map((rule) => (
                    <li key={rule}>{rule}</li>
                  ))}
                </ul>
                <ul className="m-0 mt-5 list-disc pl-5 font-['DungGeunMo'] text-[14px] leading-[1.4] text-[#f6475f]">
                  <li>{info.reward}</li>
                </ul>
              </div>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}
